import FileSelectDropdown from "@root/components/filemanagement.tsx/file-selection-dropdown";
import { OutsideCloseWrapper } from "./outside-close-wrapper";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { useProjects } from "@root/hooks/useProjects";
import { Box } from "@chakra-ui/react";
import { useEffect } from "react";
import { PAGINATION_DEFAULTS } from "@root/constants";
import { Page } from "react-pdf";
interface FileSelectMenuProps {
  onChange?: (file: any) => void;
  onClose: () => void;
}
export const FileSelectMenu: React.FC<FileSelectMenuProps> = ({
  onChange,
  onClose,
}) => {
  const { selectedProject } = useMainChatContext();
  const {
    fetchFolders,
    foldersData,
    page,
    setPage,
    folderCount,
    getFolderLoading,
  }: any = useProjects();
  useEffect(() => {
    if (selectedProject) {
      fetchFolders({
        projectId: selectedProject,
        limit: PAGINATION_DEFAULTS.PAGESIZE,
        page: page,
      });
    }
  }, [selectedProject]);
  return (
    <Box position="relative">
      <OutsideCloseWrapper onClose={onClose}>
        <Box
          position="absolute"
          bottom="100%" // ⬆ POSITION ABOVE TRIGGER
          mb="8px" // small gap
          left="0"
          zIndex={9999} // stay on top
        >
          <FileSelectDropdown
            folders={foldersData}
            isLoading={getFolderLoading}
            onFileSelect={(file: any) => {
              onChange?.(file);
              onClose?.();
            }}
            fetchFolders={fetchFolders}
            page={page}
            setPage={setPage}
            folderCount={folderCount}
          />
        </Box>
      </OutsideCloseWrapper>
    </Box>
  );
};
